import UK from "./appUK";
import DK from "./appDK";

const appLangs = {
	UK,
	EN: UK,
	DK
};
export default appLangs;


// WEBPACK FOOTER //
// ./src/components/langs/appIndex.js